import AddReactionRoundedIcon from '@mui/icons-material/AddReactionRounded';
import EmojiPeopleRoundedIcon from '@mui/icons-material/EmojiPeopleRounded';
import LocationCityRoundedIcon from '@mui/icons-material/LocationCityRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import { Box, Chip, Stack } from '@mui/joy';
import AspectRatio from '@mui/joy/AspectRatio';
import Button from '@mui/joy/Button';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import { useState } from 'react';
import useTopic from '../../hooks/useTopic';
import { useUser } from '../../hooks/useUser';
import { joinTopic, leaveTopic } from '../../redux/services/topicService';

type TopicInfoCardProps = {
  topicID: string;
};

export const TopicInfoCard = (props: TopicInfoCardProps) => {
  const topicQuery = useTopic(props.topicID);
  const userQuery = useUser();
  const [loading, setLoading] = useState(false);

  if (!topicQuery.isSuccess || !userQuery.isSuccess) {
    return null;
  }

  const follow = async () => {
    try {
      setLoading(true);
      await joinTopic(props.topicID);
      await topicQuery.refetch();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const unfollow = async () => {
    try {
      setLoading(true);
      await leaveTopic(props.topicID);
      await topicQuery.refetch();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const topic = topicQuery.data;
  const user = userQuery.data;

  const isFollowing = topic.members.some(
    (member: any) => member._id === user._id
  );

  return (
    <Card variant="outlined">
      <Stack>
        <Typography level="title-lg">{topic.title}</Typography>
        <Typography level="body-sm">{topic.description}</Typography>
      </Stack>
      <AspectRatio ratio="4/3">
        <img src={topic.bannerImage} loading="lazy" alt="" />
      </AspectRatio>
      <CardContent orientation="vertical">
        <Stack spacing={3}>
          <div>
            <Chip
              startDecorator={<EmojiPeopleRoundedIcon />}
              sx={{ margin: '.2rem', padding: '.2rem .5rem' }}
            >
              {topic.members.length} deelnemers
            </Chip>
            <Chip
              startDecorator={<LocationCityRoundedIcon />}
              sx={{ margin: '.2rem', padding: '.2rem .5rem' }}
            >
              Vestiging: {topic.branch}
            </Chip>
            <Chip
              startDecorator={<Person2RoundedIcon />}
              sx={{ margin: '.2rem', padding: '.2rem .5rem' }}
            >
              Beheerder: {topic.owner?.firstName}
            </Chip>
          </div>

          <Box>
            {isFollowing ? (
              <Button
                onClick={unfollow}
                loading={loading}
                startDecorator={<LogoutRoundedIcon />}
              >
                Verlaten
              </Button>
            ) : (
              <Button
                onClick={follow}
                loading={loading}
                startDecorator={<AddReactionRoundedIcon />}
              >
                Volgen
              </Button>
            )}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};
